export default __webpack_public_path__ + "static/media/RasterTile_Variant01.021b8269.jpg";